import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./Signin.css";

const SignIn = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!email || !password) {
      alert("Email and password required");
      return;
    }

    try {
      setLoading(true);

      const res = await axios.post(
        "http://localhost:5000/api/auth/login",
        {
          email,
          password
          // ⚠️ do NOT send requireAdmin here (customer login)
        }
      );

      // ✅ Save auth data
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user", JSON.stringify(res.data.user));

      // ✅ Redirect
      navigate("/");
    } catch (error) {
      if (error.response?.status === 401) {
        alert("Invalid email or password");
      } else if (error.response?.status === 403) {
        alert("You are not authorized");
      } else {
        alert("Login failed. Try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container container-narrow py-5">
      <div className="row g-5">
        <div className="col-lg-6">
          <h6 className="mb-4">Account Information</h6>

          <div className="mb-3">
            <label className="form-label">Email address *</label>
            <input
              className="form-control"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Password *</label>
            <div className="input-group">
              <input
                type={showPassword ? "text" : "password"}
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <span
                className="input-group-text bg-white"
                onClick={() => setShowPassword(!showPassword)}
                style={{ cursor: "pointer" }}
              >
                {showPassword ? "🙈" : "👁"}
              </span>
            </div>
          </div>

          <button
            className="btn btn-nx w-100 mb-3"
            onClick={handleLogin}
            disabled={loading}
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>

          <div className="text-center small-link">
            Don’t have an account? <a href="/register">Create one</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
